const state = () => ({
  navList: [],
});

const getters = {
  navList: (state) => state.navList,
};

const mutations = {
  setNavList(state, navList) {
    state.navList = navList;
  },
};

const actions = {};

export default { state, getters, mutations, actions };
